export const CONSUMER_PORTAL_MODULES = [
  { key: 'dashboard', name: 'Dashboard' },
  { key: 'games', name: 'Games' },
  { key: 'users', name: 'Players' },
  { key: 'battles', name: 'Battles' },
  { key: 'transactions', name: 'Transactions' },
  { key: 'private-tables', name: 'Private Tables' },
] as const;

export const DEFAULT_CONSUMER_PORTAL_PERMISSIONS = ['dashboard', 'games', 'users', 'private-tables'];
